import { Box } from '@mui/material';
import React from 'react';
import ASTITitle from '../../labels/ASTITitle';
import ASTIText from '../../labels/ASTIText';

export default function Teachers() {
  return (
    <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    width="100%"
    gap={4}>
      <ASTITitle text="Hall of Famous Teachers" />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        gap={2}
      >
        <ASTIText text="Meg Buzza" />
        <ASTIText text="(@MegaBuzza) - Cast member of Boom Chicago" />
        <ASTIText text="Brad Kemp" />
        <ASTIText text="Brad Kemp (@bradkempmusic) - Artistic & Musical Director of Boom Chicago" />
        <ASTIText text="Rob AndristPlourde"/>
        <ASTIText text="(@randristplourde) - Cast member of Boom Chicago"/>
        <ASTIText text="MC Hammersmith"/>
        <ASTIText text="(@mc_hammersmith)- UK comedy rapping legend"/>
        <ASTIText text="Douglas Widick, RJ Williams, Ralf Jean Pierre" />
        <ASTIText text="(@northcoastnyc)" />
        <ASTIText text="Raquel Palmas" />
        <ASTIText text="(@rockwell826) NorthCoast NYC/Boom Chicago/Shamilton)" />
        <ASTIText text="Ryan Millar" />
        <ASTIText text="(@ryanscottmillar)" />
        <ASTIText text="Lee Apsey" />
        <ASTIText text="(@leeapsey - Slice of Rhyme)" />
        <ASTIText text="Marco Meurs" />
        <ASTIText text="(https://marcomeurs.nl/)" />
        <ASTIText text="Larry Dorsey" />
        <ASTIText text="(@larrydorseyjr)" />'
        <ASTIText text="Contact and/or book us !! Follow us and send us a DM on Instagram -> @astir.oids" />
      </Box>
    </Box>
  );
}
